import { FIRST_NODE_ID } from "../../config/config"
import { Story } from "../../config/story.types"

const NODES = {
  START: FIRST_NODE_ID,
  WRONG: "WRONG",
  SUCCESS: "SUCCESS",
  DEUX: "DEUX",
}

export const story: Story = {
  [NODES.START]: {
    botMessages: [
      "Bienvenue dans l'enquête.",
      "Un objet a disparu cette nuit.",
    ],
    question: {
      type: "choice",
      choices: [
        { label: "Un bijou", next: NODES.DEUX },
        { label: "Un document secret", next: NODES.SUCCESS },
      ],
    },
  },
  [NODES.DEUX]: {
    botMessages: [
      "Bienvenue dans l'enquête.",
      "Un objet a disparu cette nuit.",
    ],
    question: {
      type: "choice",
      choices: [
        { label: "Un bijou", next: NODES.WRONG },
        { label: "Un document secret", next: NODES.SUCCESS },
      ],
    },
  },
  [NODES.WRONG]: {
    botMessages: ["Ce n'est pas le bon objet."],
    question: {
      type: "choice",
      choices: [{ label: "Réessayer", next: NODES.START }],
    },
  },
  [NODES.SUCCESS]: {
    botMessages: ["Exact. L'enquête commence maintenant 🔍"],
  },
}
